/* eslint-disable */
import auth0 from 'auth0-js'
import { AUTH_CONFIG } from './auth0-variables'
import EventEmitter from 'eventemitter3'
import router from '../router'
import { store } from '../store/store'
import loggingService from '@/services/util/loggingService'

const isDebug = false
const lsKeySignedIn = 'ccms_signin_auth0'

const webAuth = new auth0.WebAuth({
    domain: AUTH_CONFIG.domain,
    clientID: AUTH_CONFIG.clientId,
    redirectUri: AUTH_CONFIG.callbackUrl,
    audience: `https://${AUTH_CONFIG.domain}/userinfo`,
    responseType: 'token id_token',
    scope: 'openid profile email'
})

export default class AuthService {

    authenticated = this.isAuthenticated()
    authNotifier = new EventEmitter()
    idToken = null
    profile = null
    tokenExpiry = null

    constructor() {
        this.login = this.login.bind(this)
        this.setSession = this.setSession.bind(this)
        this.logout = this.logout.bind(this)
        this.isAuthenticated = this.isAuthenticated.bind(this)
        this.authenticated = this.isAuthenticated()
        this.renewTokens = this.renewTokens.bind(this)
        // this.authNotifier = new EventEmitter()
        // this.auth0 = new auth0.WebAuth({
        // domain: AUTH_CONFIG.domain,
        // clientID: AUTH_CONFIG.clientId,
        // redirectUri: AUTH_CONFIG.callbackUrl,
        // audience: `https://${AUTH_CONFIG.domain}/userinfo`,
        // responseType: 'token id_token',
        // scope: 'openid profile email'
        // })
    }

    login () {
        webAuth.authorize()
    }

    handleAuthentication () {
        console.log('handleAuthentication')
        webAuth.parseHash((err, authResult) => {
        if (authResult && authResult.accessToken && authResult.idToken) {
            this.setSession(authResult)
            router.replace('/')
        } else if (err) {
            router.replace('/')
            console.log(err)
            alert(`Error: ${err.error}. Check the console for further details.`)
        }
        })
    }

    setSession (authResult) {
        this.idToken = authResult.idToken
        this.profile = authResult.idTokenPayload
        this.tokenExpiry = new Date(this.profile.exp * 1000)
        // Set the time that the access token will expire at
        let expiresAt = JSON.stringify(
            //authResult.expiresIn * 1000 + new Date().getTime()
            this.profile.exp * 1000
        )
        loggingService.log(isDebug, 'authService', 'token expires at: ' + this.tokenExpiry)
        //loggingService.log(isDebug, 'authService', 'old token expires at: ' + new Date(authResult.expiresIn * 1000 + new Date().getTime()))
        
        localStorage.setItem('isUserSigninWithAuth0', true)
        localStorage.setItem('access_token', authResult.accessToken)
        localStorage.setItem('id_token', authResult.idToken)
        localStorage.setItem('expires_at', expiresAt)
        localStorage.setItem('profile', JSON.stringify(authResult.idTokenPayload))
        localStorage.setItem(lsKeySignedIn, 'true')
        //localStorage.setItem('authResult', JSON.stringify(authResult))
        this.authenticated = this.isAuthenticated()
        this.authNotifier.emit('authChange', { authenticated: true, authResult: authResult})
    }

    logout () {
        this.idToken = null
        this.tokenExpiry = null
        this.profile = null
        store.dispatch('logout')
        // Clear access token and ID token from local storage
        localStorage.removeItem('access_token')
        localStorage.removeItem('id_token')
        localStorage.removeItem('expires_at')
        localStorage.removeItem('profile')
        localStorage.removeItem('isUserSigninWithAuth0')
        localStorage.removeItem(lsKeySignedIn)
        //localStorage.removeItem('authResult')
        this.userProfile = null
        this.authenticated = this.isAuthenticated()
        this.authNotifier.emit('authChange', { authenticated: false})
        // navigate to the home route and reload page
        webAuth.logout({
            returnTo: window.location.origin
        })
        window.location.href = '/'
        //router.push('/', () => {location.reload()})
    }

    isAuthenticated () {
        // Check whether the current time is past the expiry time
        let expiresAt = JSON.parse(localStorage.getItem('expires_at'))
        let timeNow = new Date().getTime()
        //loggingService.log(isDebug, 'authService - expiresAt', expiresAt)
        //loggingService.log(isDebug, 'authService - time now', timeNow)
        return (timeNow < expiresAt) && (localStorage.getItem(lsKeySignedIn) === 'true')
    }

    renewTokens () {
        loggingService.log(isDebug, 'authSerivce', 'renewTokens')
        return new Promise((resolve, reject) => {
            if (localStorage.getItem(lsKeySignedIn) !== 'true') {
                loggingService.log(isDebug, 'authService', 'renewTokens - error - User not logged in')
                return reject('User not logged in')
            }
            webAuth.checkSession({}, (err, authResult) => {
                if (err) {
                    loggingService.log(isDebug, 'authService', 'renewTokens - error')
                    loggingService.logRaw(isDebug, err)
                    this.logout()
                    reject(err)
                } else {
                    loggingService.log(isDebug, 'authService', 'renewTokens - success')
                    loggingService.logRaw(isDebug, authResult)
                    this.setSession(authResult)
                    resolve(authResult)
                }
            })
        })
    }
}